module.exports = __webpack_public_path__ + "static/media/waiterpls.d9d8d007.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/waiterpls.png
// module id = 2068
// module chunks = 0